import { render, staticRenderFns } from "./MobilePlans_variant1.vue?vue&type=template&id=751570cc"
import script from "./MobilePlans_variant1.vue?vue&type=script&lang=js"
export * from "./MobilePlans_variant1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports